import {Pipe, PipeTransform} from "@angular/core";
import {IntermediatePriceAdjustment, IntermediatePriceAdjustmentType} from "./pricing-adjustments.component";
import {AccreditationBody, StandardName} from "../../../../store/state/order.state";

@Pipe({
    name: 'adjustmentName',
    standalone: false
})
export class AdjustmentNamePipe implements PipeTransform {

	transform(adjustment: IntermediatePriceAdjustment, standard: StandardName, accBody: AccreditationBody): string {
		if (adjustment.type === IntermediatePriceAdjustmentType.RISK && accBody != AccreditationBody.RVA) {
			return standard === StandardName.ISO_9001 ? 'RISK FACTOR' : 'COMPLEXITY FACTOR';
		} else if (adjustment.type == IntermediatePriceAdjustmentType.IT_COMPLEXITY) {
			return standard === StandardName.ISO_27701 ? 'PRIVATE INFORMATION AVAILABILITY' : 'IT COMPLEXITY';
		}

		if (accBody === AccreditationBody.RVA) {
			if (adjustment.type === IntermediatePriceAdjustmentType.RISK && [StandardName.ISO_14001, StandardName.ISO_45001].includes(standard)) {
				return 'RISK LEVEL';
			} else if (adjustment.type === IntermediatePriceAdjustmentType.COMPLEXITY_FACTOR && standard === StandardName.ISO_45001) {
				return 'COMPLEXITY RISK FACTOR';
			} else {
				return adjustment.type.replace('_', ' ');
			}
		}

		return adjustment.type.replace('_', ' ');
	}
}
